export enum SortOrder {
    ASC,
    DESC
}
